import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/apiClient';
import { templateKeys } from './useTemplates';
import type { CreateTemplateRequest, Template } from '../../lib/types/template.types';

/**
 * Create a new template mutation
 * Invalidates template list cache on success
 *
 * @returns Mutation object with mutate function
 *
 * @example
 * const createTemplate = useCreateTemplate();
 * createTemplate.mutate({
 *   name: 'Welcome Message',
 *   content: { blocks: [{ type: 'text', content: 'Hi {{name}}!' }] }
 * });
 */
export function useCreateTemplate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateTemplateRequest) => {
      const { data: template } = await api.post<Template>('/api/templates', data);
      return template;
    },
    onSuccess: () => {
      // Invalidate all list queries to refetch
      queryClient.invalidateQueries({ queryKey: templateKeys.lists() });
    },
  });
}
